import { EType } from '@/types/goal';
import { BookOpen, Eye, Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ETypeTagProps {
  type: EType;
  size?: 'sm' | 'md';
}

const config: Record<EType, { label: string; icon: React.ReactNode; className: string }> = {
  education: {
    label: 'Education',
    icon: <BookOpen className="w-3 h-3" />,
    className: 'tag-education',
  },
  exposure: {
    label: 'Exposure',
    icon: <Eye className="w-3 h-3" />,
    className: 'tag-exposure',
  },
  experience: {
    label: 'Experience',
    icon: <Zap className="w-3 h-3" />,
    className: 'tag-experience',
  },
};

export const ETypeTag = ({ type, size = 'sm' }: ETypeTagProps) => {
  const { label, icon, className } = config[type];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium',
        size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
        className
      )}
    >
      {icon}
      {label}
    </span>
  );
};
